import { lazy, Suspense } from 'react';
import { useAuth } from '@/services/auth';
import { isFlexPlan } from '@/services/auth/plan-slugs';

// Load this lazily. The Add funds flow imports the purchase modals and Stripe. A static import adds
// them to the top nav for all accounts, and the page load event was 1.3s slower.
const LazyFlexCreditsDropdown = lazy(() =>
  import('./flex-credits-dropdown').then((m) => ({ default: m.FlexCreditsDropdown })),
);

/** Shows the credits pill for Flex accounts only. Other accounts do not load its code or data. */
export function CreditsDropdown() {
  const { account } = useAuth();
  if (!isFlexPlan(account)) return null;

  return (
    <Suspense fallback={null}>
      <LazyFlexCreditsDropdown />
    </Suspense>
  );
}
